import PubSub from 'pubsub-js';

// The debounce function receives our function as a parameter
const debounce = (fn) => {

    // This holds the requestAnimationFrame reference, so we can cancel it if we wish
    let frame;

    // The debounce function returns a new function that can receive a variable number of arguments
    return (...params) => {

        // If the frame variable has been defined, clear it now, and queue for next frame
        if (frame) {
            cancelAnimationFrame(frame);
        }

        // Queue our function call for the next frame
        frame = requestAnimationFrame(() => {

            // Call our function and pass any params we received
            fn(...params);
        });

    }
};

const top = document.getElementById("top");
const content = document.getElementById("content");
let scrollPosition = window.scrollY;

// Reads out the scroll position of the #top element and stores it in the data attribute
// so we can use it in our stylesheets
const storeScroll = () => {

    if (scrollPosition < window.scrollY) {
        top.classList.add("is-scrolling-down");
    } else if (scrollPosition > window.scrollY) {
        top.classList.remove("is-scrolling-down");
    }
    scrollPosition = window.scrollY;

    if (window.scrollY > top.offsetHeight) {
        top.classList.add("is-scrolled-past");
    } else if (window.scrollY < top.offsetHeight){
        top.classList.remove("is-scrolled-past");
    }

    if (window.scrollY > 3) {
        top.classList.add("is-scrolled");
    } else if (window.scrollY < 1){
        top.classList.remove("is-scrolled");
    }

    let contentTop = content.getBoundingClientRect().top;
    if (0 > contentTop) {
        //top.classList.add("is-scrolled-content");
        PubSub.publish('scroll.content', { direction : 'down' });
    } else if (0 < contentTop){
        //top.classList.remove("is-scrolled-content");
        PubSub.publish('scroll.content', { direction : 'up' });
    }
};

let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

if ( ! isIE11) {

    // Listen for new scroll events, here we debounce our `storeScroll` function
    document.addEventListener('scroll', debounce(storeScroll), {passive: true});

    // Update scroll position for first time
    storeScroll();
}